/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { List } from '@app/data-model/list/list';

const defaultConfig = {
  isFilterable: false,
  isSortable: false,
  isClickable: false
};

function slugify(str) {
  const from = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșšŝťțŭùúüűûñÿýçżźž',
    to = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssttuuuuuunyyczzz';

  // Replace special characters with their ASCII equivalents
  str = str
    .toLowerCase()
    .split('')
    .map(c => {
      const index = from.indexOf(c);
      return index !== -1 ? to.charAt(index) : c;
    })
    .join('');

  // Replace non-word characters (except spaces and hyphens) with hyphens
  str = str.replace(/[^\w\s-]/g, '-');

  // Replace sequences of hyphens, underscores, and spaces with a single hyphen
  str = str.replace(/[-_\s]+/g, '-');

  // Remove leading and trailing hyphens
  str = str.replace(/^-{1,100}/, '').replace(/-{1,100}$/, '');

  return str;
}

export class NavigatorList extends List {
  isFilterable: boolean;
  filterData: any;
  isSortable: boolean;
  sortData: any;
  isClickable: boolean;
  childTemplateUrl: string;
  isOpen: boolean;
  icons: Array<any>;
  addFunction: any;
  addEvent: string;
  isCollapsible: boolean;
  disableScroll: boolean;
  displayName: string;
  checksum: number = undefined;

  constructor(displayName: string, config?: any) {
    super('navigator-list');

    this.id = slugify(displayName);

    config = config || defaultConfig;

    this.displayName = displayName;
    this.isFilterable = !!config.isFilterable;
    this.isSortable = !!config.isSortable;
    this.isClickable = !!config.isClickable;
    this.isOpen = config.isOpen;
    this.isCollapsible = typeof config.isOpen === 'boolean';
    this.disableScroll = !!config.disableScroll;
    this.icons = config.icons;
    this.addFunction = config.addFunction;
    this.addEvent = config.addEvent;
  }

  get hasCount() {
    return !!this.count && this.count.total !== undefined;
  }

  get hasBadChecksum() {
    return this.checksum < 0;
  }

  get canAdd() {
    return (!!this.addFunction || !!this.addEvent) && !!this.icons && !!this.icons.length;
  }

  get isFiltered() {
    return !!this.filterData;
  }

  get isSorted() {
    return !!this.sortData && this.sortData.item;
  }
}
